export default "__VITE_ASSET__RXa5ilvZ__"